import { createAsyncThunk } from '@reduxjs/toolkit'
import ApprovedSeries from './approved-series-model'
import {
  delete_approvedSeries,
  load_approvedSeriess,
  store_approvedSeries,
} from './approvedSeries-service'

export const LoadApprovedSeriessAsync = createAsyncThunk<any, any>(
  'composer/load/approvedSeries',
  async (params: { uid: string }) => {
    return await load_approvedSeriess(params)
  },
)

export const CreateApprovedSeriesAsync = createAsyncThunk<any, any>(
  'composer/create/approvedSeries',
  async (params: ApprovedSeries) => {
    return await store_approvedSeries(params)
  },
)

export const DeleteApprovedSeriesAsync = createAsyncThunk<any, any>(
  'composer/delete/approvedSeries',
  async (params) => {
    return await delete_approvedSeries(params)
  },
)
